export default __webpack_public_path__ + "static/whoweare-daa4f33d1ba82a26645f98e1c4b316fe.png";